<script>
	import { brand } from "src/brand";
	import { Table } from "@sveltestrap/sveltestrap";
	import CustomInput from "../CustomInput/CustomInput.svelte";

	export let items = [];
	export let updateAmount = () => {};
	export let isEditable = false;
</script>

<Table>
	<thead>
		<tr>
			<td>
				<b> No. </b>
			</td>
			<td>
				<b> Items </b>
			</td>
			<td>
				<b> Amount ({brand.currencySymbol}) </b>
			</td>
		</tr>
	</thead>
	<tbody>
		{#each items as { item, value }, i}
			<tr>
				<td>{i + 1}</td>
				<td>
					<span>{item}</span>
				</td>
				<td>
					{#if !isEditable}
						<div class="text-end">{value?.toFixed(2)}</div>
					{:else}
						<CustomInput
							id={`input-${i}-amount`}
							type="number"
							placeholder={`0.00`}
							bind:value
							classes="search-border text-end"
							onChange={(e) => updateAmount(e.target.value, i)}
						/>
					{/if}
				</td>
			</tr>
		{/each}
	</tbody>
	<tfoot>
		<tr>
			<td colspan="2" style="text-align: right; font-weight: bold;"
				>Total Billable Amount</td
			>
			<td
				style={`font-weight: bold; padding: ${
					!isEditable ? "14px" : "34px"
				} !important;`}
				class="text-end"
			>
				{items
					.reduce((total, { value }) => total + (value || 0), 0)
					.toFixed(2)}
			</td>
		</tr>
	</tfoot>
</Table>

<style>
	table {
		width: 100%;
		border-collapse: collapse;
	}
	th,
	td {
		border: 1px solid #ddd;
		padding: 8px;
		text-align: left;
	}
	th {
		background: #f4f4f4;
	}
	input[type="number"] {
		width: 100px;
	}
</style>
